import { Fragment, useEffect } from "react";
import { Input, Typography } from "@material-tailwind/react";
import NextBack from "./NextBack";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  createBoatForm,
  createBoatSchema,
} from "../../pages/boat/createBoatValidation";
import ErrorParagraph from "../common/ErrorParagraph";
import SelectDate from "../common/SelectDate";
import { useOnboardingStore } from "../../store/onboarding/Onboarding";
import { useBoatDetailsStore } from "../../store/boat/boatDetails";
import { toast } from "react-toastify";

function BoatDetails() {
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors, isValid },
  } = useForm<createBoatForm>({
    resolver: yupResolver(createBoatSchema),
    mode: "onTouched",
  });

  const { setStepNumber,  setOnBoardingPage, setTab } =
    useOnboardingStore();
  const { setBoatDetails, boat } = useBoatDetailsStore();
  const onSubmit = (data: createBoatForm) => {
    console.log(data);

    setBoatDetails(data);
    setStepNumber(2);
    setOnBoardingPage("Address");
    setTab("Address");
  };
  useEffect(() => {
    reset(boat);
  }, [reset, boat]);

  return (
    <Fragment>
      <Typography  placeholder={undefined}  className="font-semibold text-2xl mb-4 text-center">
        Create Boat
      </Typography>

      <form
        className="flex flex-col items-center"
        onSubmit={() => {
          handleSubmit(onSubmit);
        }}
      >
        <div className=" m-2 md:w-1/2 w-full">
          <Input
            crossOrigin={undefined}
            label="Brand Name"
            {...register("brand")}
            className="bg-white border-none"
            value={boat?.brand}
            onChange={(e) => {
              setBoatDetails({ ...boat, brand: e.target.value });
            }}
          />
          {errors.brand && (
            <ErrorParagraph message={errors.brand.message!}></ErrorParagraph>
          )}
        </div>

        <div className=" m-2 md:w-1/2 w-full">
          <Input
            className="bg-white border-none"
            crossOrigin={undefined}
            label="Boat Model"
            {...register("model")}
            value={boat?.model}
            onChange={(e) => {
              setBoatDetails({ ...boat, model: e.target.value });
            }}
          />
          {errors.model && (
            <ErrorParagraph message={errors.model.message!}></ErrorParagraph>
          )}
        </div>

        <div className=" m-2 md:w-1/2 w-full">
          <Input
            className="bg-white border-none"
            crossOrigin={undefined}
            label="Boat color"
            {...register("color")}
            value={boat?.color}
            onChange={(e) => {
              setBoatDetails({ ...boat, color: e.target.value });
            }}
          />
          {errors.color && (
            <ErrorParagraph message={errors.color.message!}></ErrorParagraph>
          )}
        </div>
        <SelectDate
          selectDateProps={{
            label: "Boat Year",
            setDate: (date) => {
              setValue("boatYear", date);
              setBoatDetails({ ...boat, boatYear: date });
            },
            date: boat.boatYear,
          }}
        />
        <SelectDate
          selectDateProps={{
            label: "Last Maintenance date",
            setDate: (date) => {
              setValue("lastMaintenance", date);
              setBoatDetails({ ...boat, lastMaintenance: date });
            },
            date: boat.lastMaintenance,
          }}
        />
      </form>
      <NextBack
        shouldGoNext={isValid}
        shouldGoBack={false}
        next={() => handleSubmit(onSubmit)()}
        back={() => {
          toast.error("you cannot go back on this page");
        }}
      />
    </Fragment>
  );
}

export default BoatDetails;
